import { render } from "./message.vue?vue&type=template&id=cc5bdd50&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"

import "./message.vue?vue&type=style&index=0&id=cc5bdd50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc5bdd50"]])

export default __exports__